import FileController from "./FileController";
import AnnotController from "./AnnotController"
import PDFViewController from './PDFViewerController'
import { PERMISSION_KEYS } from "./FileController";
import ConvertController from "./ConvertController";
import PreferenceFullScreenController from './PreferenceFullScreenController';

const fileController = new FileController();
const annotController = new AnnotController()
const convertController = new ConvertController();
const pdfViewController = new PDFViewController();
const preferenceFullScreenController = new PreferenceFullScreenController();

window.__fileController__ = fileController;

export {
    fileController,
    annotController,
    pdfViewController,
    PERMISSION_KEYS,
    convertController,
    preferenceFullScreenController
}